module.exports = __webpack_public_path__ + "045eca315c47c2f5b8ce8e10881fd96e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/social-media-icons/email.png
// module id = 3463
// module chunks = 0